import React, {Component} from 'react';
import MagnitudeDashboardChart from './MagnitudeDashboardChart'
//import Select from '@material/react-select';
import {//Headline4,
    Headline5,
Headline6,
Subtitle1,
// Subtitle2
} from '@material/react-typography'
import Carousel from 'nuka-carousel';
import {median} from 'mathjs/number'
import {mean} from 'mathjs/number'
import {round} from 'mathjs/number'

import { ThemeContext } from '../../themeContext';


class MagnitudeDashboardContainer extends Component {

    constructor(props) {
        super(props)

        this.state = {
            dimension: Object.keys(props.dimensions)[0]
        }
    }

    _computeColumnData(data, columnName) {
        if (!data || !columnName) return []

        return data.filter((datum)=> datum[columnName] !== undefined).map((datum)=> datum[columnName] )
    }

    _computeDimensionColumnData(data, dimCat, dimension, columnName) {
        if (!data || !columnName || !dimCat) return []

        return data.filter((datum)=> datum[dimension] === dimCat && datum[dimension] !== undefined && datum[columnName] !== undefined).map((datum)=> datum[columnName] )
    }

    computeDimensionStatsTable(colList, data, statToCompute, dimCat, dimension) {
        if (!colList  || !data || !statToCompute || !dimCat || !dimension) return;
        let statFn = null;
        if (statToCompute === 'median') {
            statFn = median
        }else if(statToCompute === 'mean') {
            statFn = mean
        }
        
        return colList.map(col=>{
            const columnData = this._computeDimensionColumnData(data, dimCat, dimension, col.name)
            if (columnData.length === 0) {
                return {}
            }
            return {
                variable: col.title,
                stat: round(statFn(columnData),1)
            }
        })
    }


    computeStatsTable(colList, data, statToCompute) {

        if (!colList || !data || !statToCompute ) return;
        let statFn = null;
        if (statToCompute === 'median') {
            statFn = median
        }else if(statToCompute === 'mean') {
            statFn = mean
        }
         
        return colList.map(col=>{
            const columnData = this._computeColumnData(data, col.name)
            if (columnData.length === 0) {
                return {}
            }
            return {
                variable: col.title,
                stat: round(statFn(columnData),1)
            }
        })
    }

    tableIsEmpty(table) {
       
        for (let row of table) {
            if (row['variable'] && row['stat']) return false
        }

        return true
    }
  
    render() {
        
        let slidesToShow = 1.1
        const slideIndex = 0;
        let withoutControls = true
        if (this.props.isMediumScreen) {
            slidesToShow = 2.05
            // withoutControls = false
        }

        if (this.props.isLargeScreen) {
            slidesToShow = 3.05
            withoutControls = false
        }
        
        const theme = this.context.theme;
        const headlineStyle = {
            color: theme.color
        }
        
        const statsTable = this.computeStatsTable(this.props.metricColumns, this.props.data, this.props.statsName);

        let statsData =  statsTable.sort((a, b)=> b.stat - a.stat).map(row=> row.stat)
        let variableList = statsTable.map(row=> row.variable)

        let dimensionCategories = [];
        
      
        for (let key in this.props.dimensions[this.state.dimension]) {
            dimensionCategories.push(this.props.dimensions[this.state.dimension][key])
        }  
        
        
        const charts = dimensionCategories.map(dimCat=>{
            let dimStatData = [];
            let dimVariableList = [];
           // compute stats Table
            const dimStatsTable = this.computeDimensionStatsTable(this.props.metricColumns, this.props.data, this.props.statsName, dimCat,  this.state.dimension);           
          
            if (!this.tableIsEmpty(dimStatsTable) ) {
                
                dimStatData =  dimStatsTable.sort((a, b)=> b.stat - a.stat).map(row=> row.stat)
                dimVariableList = statsTable.map(row=> row.variable)
            }
            return (
                <MagnitudeDashboardChart className="rankAndMagChart" xvalues={dimVariableList}
                yvalues= {dimStatData} 
                yAxisTitle={"Hours Per Week"}
                handleSelectedDatapoint={()=>{}} 
                selectedRankedItem={''}
                chartHeight={350}
                metricUnit='Hrs'
                colors={['#ff0266']}>
                     <Headline6 className="headline6">{dimCat}</Headline6>                                                      
                </MagnitudeDashboardChart>
            )
           
        })
         
        return (
            <div className="rankAndMagnitudeChart-container">
                 <Headline5 className="headline5">{this.props.dashboardTitle}</Headline5>
                 <Subtitle1 className="subtitle1">Select any data point to see the average Time spent</Subtitle1>
                <Headline6 className="headline6" style={headlineStyle}>{this.props.overallChartTitle}</Headline6>
                <MagnitudeDashboardChart  className="rankAndMagChart home-overallChart" xvalues={variableList}
                                    yvalues= {statsData} 
                                    yAxisTitle={"Hours Per Week"}
                                    handleSelectedDatapoint={()=>{}} 
                                    selectedRankedItem={''}
                                    chartHeight={350}
                                    metricUnit='Hrs'
                                    colors={['#ff0266']}>
                         <Headline6 className="headline6">Overall</Headline6>
                </MagnitudeDashboardChart>

                <Headline6 className="headline6" style={headlineStyle}>{this.props.dimensionChartsTitle} {this.props.dimensionLabels[this.state.dimension]} </Headline6>                                    
                <div className="randAndMagnitudeChart-dimensionChartList">
                    <Carousel key={this.state.dimension} slidesToShow={slidesToShow} cellSpacing={16} slidesToScroll={1} slideIndex={slideIndex} slideWidth={1.0} 
                                dragging swiping withoutControls={withoutControls}>
                        {charts}
                    </Carousel>
                </div>
            </div>

        )
    }
}

MagnitudeDashboardContainer.contextType = ThemeContext;

export default MagnitudeDashboardContainer